import "./Edit/ConfigurationGroupCareEditComponent";
import "./SiteConfigurationGroupCare.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteConfigurationGroupCareComponentController from "./SiteConfigurationGroupCareComponentController";

export class SiteConfigurationGroupCareComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            configurationGroup: "<",
            deleted: "&?",
        };
        this.controller = SiteConfigurationGroupCareComponentController;
        this.templateUrl = "/App/Components/Site/ConfigurationGroups/Care/SiteConfigurationGroupCare.html";
    }
}

module("mmManagePortal").component("mmSiteConfigurationGroupCare", new SiteConfigurationGroupCareComponent());
